import jsonLogic from 'json-logic-js';

import type { TRule } from '@ballerine/common';

import type { TRuleEngineRunner } from '../../types';

export const jsonLogicEngineRunner: TRuleEngineRunner = (context: object, rule: TRule) => {
  jsonLogic.add_operation(
    'date_shift',
    (date: string, amount: number, unit: 'days' | 'months' | 'years') => {
      const inputDate = new Date(date === 'now' ? new Date() : date);

      if (isNaN(inputDate.getTime())) {
        throw new Error(`Invalid date: ${String(date)}`);
      }

      const result = new Date(inputDate);

      switch (unit) {
        case 'days':
          result.setDate(result.getDate() + amount);
          break;
        case 'months':
          result.setMonth(result.getMonth() + amount);
          break;
        case 'years':
          result.setFullYear(result.getFullYear() + amount);
          break;
        default:
          throw new Error(`Unsupported date unit: ${String(unit)}`);
      }

      return result.toISOString();
    },
  );

  if (typeof rule.value !== 'object' || rule.value === null) {
    throw new Error('JsonLogicEngineRunner: Rule value must be an object');
  }

  const result = jsonLogic.apply(rule.value, context);

  if (typeof result !== 'boolean') {
    console.warn('JsonLogicEngineRunner: Rule result is not a boolean', result);
    console.warn('Result will be converted to boolean');
  }

  return Boolean(result);
};
